<template>
    <div class="ah-panel outsourcing-contact-list-edit">
        <div class="panel-header small gray">
            <div class="panel-title">基本資訊</div>
        </div>
        <div class="panel-body">
            <transition-group name="contact">
                <el-card v-for="(contact, index) in availableList" :key="`${contact.sno}${contact.key}`" class="contact-card">
                    <div slot="header" class="clearfix">
                        <span>聯絡窗口 {{ index + 1 }}</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click.prevent="onRemove(contact)">刪除</el-button>
                    </div>
                    <el-form-item :prop="'vendorContacts.' + index + '.nam'" label="姓名">
                        <el-input v-model="contact.nam" class="input-with-select" style="max-width: 400px" :maxlength="30" :show-word-limit="true">
                            <el-select v-model="contact.gen" :prop="'contacts.' + index + '.gen'" slot="append" style="width: 100px">
                                <el-option label="先生" :value="0"></el-option>
                                <el-option label="小姐" :value="1"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item :prop="'vendorContacts.' + index + '.job'" label="職稱">
                        <el-input v-model="contact.job" style="max-width: 400px" :maxlength="20" :show-word-limit="true"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'vendorContacts.' + index + '.tel'" label="電話">
                        <el-input v-model="contact.tel" style="max-width: 400px" :maxlength="20" :show-word-limit="true"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'vendorContacts.' + index + '.ext'" label="分機">
                        <el-input v-model="contact.ext" style="max-width: 150px" :maxlength="10" :show-word-limit="true"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'vendorContacts.' + index + '.eml'" label="E-mail">
                        <el-input v-model="contact.eml" style="max-width: 600px" :maxlength="100" :show-word-limit="true"></el-input>
                    </el-form-item>
                </el-card>
            </transition-group>
            <div style="text-align: right; margin-top: 10px">
                <el-button @click="onAdd" type="primary" size="small" plain>新增窗口</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        availableList() {
            return this.value.filter((o) => o.onf === 1);
        },
    },
    methods: {
        onAdd() {
            this.$emit('add');
        },
        onRemove(item) {
            this.$emit('remove', item);
        },
    },
};
</script>

<style lang="scss" scoped>
.outsourcing-contact-list-edit {
    .contact-card {
        margin-bottom: 40px;
        border-radius: 15px;
    }

    // 新增聯絡窗口動畫
    .contact-item {
        display: inline-block;
        margin-right: 10px;
    }

    .contact-enter-active {
        transition: all 0.5s;
    }

    .contact-leave-active {
        transition: all 0.1s;
    }

    .contact-enter,
    .contact-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
}
</style>
